import InvioceReport from "./InvioceA4PDFReport/Page";
import ordeRreport from "./OrderPDFReport/Page";
import StockReport from "./StockReport/PDFReport/Page";
import ItemRegisterReport from "./ItemRegisterReport/PDFReport/Page";
import VanLoadingSheet from "./Van Loading Party Wise InvoiceList/Page";
import Receipts from "./ReceiptsPDFReport/Page";
import CreditNote from "./CreditDebitPDFReport/Page";
import PartyLedgerReport from "./PratyLedger/PDFReport/Page";
import ReturnReport from "./ReturnReport/PDFReport/Page";
import MasterClaimReport from "./ClaimSummary/PDFReport/MasterClaimReport/Page";
import ItemWiseClaimReport from "./ClaimSummary/PDFReport/ItemWiseClaimReport/Page";
import CustomerWiseClaimReport from "./ClaimSummary/PDFReport/CustomerWiseClaimReport/Page";
import FrenchiesesOrderReport from "../pages/SweetPOS/Reports/OrderPDFReport/Page";
import PosInvoiceReport from "../pages/SweetPOS/Reports/InvoicePDFReport/Page";
import ordeItemSupplierReport from "./OrderItemSupplier/OrderItemSupplier/Page";
import StockEntryReport from "./StockEntry/Page";
import OrderThermalPrintReport from "../pages/SweetPOS/Reports/OrderThermalPrint/Page";
import voucherRedemptionClaimReport from "./VoucherRedemptionClaim/VoucherRedemptionClaimPDF";
import PeriodicGRNReport from "./PeriodicGRNReport/PDFReport/Page";
import CSSItemSaleReport from "./CssItemSaleReport/PDFReport/Page";
import CashierSummaryReport from "../pages/SweetPOS/Reports/CashierSummaryReport/Page";
import ManagerSummaryReport from "../pages/SweetPOS/Reports/ManagerSummaryReport/Page";
import POSSaleSummaryReport from "../pages/SweetPOS/Reports/PosSummarySaleReport/PDFReport/Page";
import SaleSummaryThermalPrintReport from "../pages/SweetPOS/Reports/PosSummarySaleReport/ThermalPrintReport/Report";
import BillDeleteSummaryReport from "./BillSummaryDeleteReport/PDFReport/Page";
import ItemConsumptionReport from "./ItemConsumptionReport/Page";
import BatchTraceabilityReport from "./BatchTracebilityReport/Page";
import StockadjustmentReport from "./StockadjustmentReport/PDFReport/Page";
import PeriodWiseItemSale from "./PartywiseItemSaleReport/PeriodWiseItemSalePDRrepot";
import { PeriodWiseInvoiceReport } from "./PeriodWiseInvoiceReport/PeriodWiseInvoicePDF";
import BillProcessingReport from "./BillProcessingReport/PDFReport/Page";
import RateListRepot from './RateListReport/PDFReport/page';
import LoyaltyReport from './LoyaltyClaimReport/PDFReport/page';
import WastageReport from "../pages/Inventory/WastageEntryMaster/PDFPrint/page";
import AnnualItemSaleReport from "./AnnualSaleReport/AnnualSaleReport";
import AnnualItemSalePDF from "./AnnualSaleReport/AnnualSalePdf";
import schemeMasterReport from "./SchemeMasterReport/SchemeMasterReport";
import InvioceReport_RAMasale from "./RAInvoice/Page";
import WastageReport1 from "../pages/Inventory/WastageEntryMaster/ReportPDF/page";
import DeliveryChallanReport_RAMasale from "./RAChallan/Challanpage";
import OrderReport_RAMasale from "./RAOrder/Page";
import CashBookReportPDF from "./CashBookEntryReport/PDFReport/Page";
import VoucherRedemptionCouponPDF from "./VoucherRedemptionClaim/Voucherredemptioncouponpdf";


export const FrenchiesesOrder = "FrenchiesesOrder"
export const order1 = "order1"
export const schemeMaster = "schemeMaster"
export const wastage1 = "wastage1"
export const wastage = "wastage"
export const invoice = "invoice"
export const RAChallan = "RAChallan"
export const RAinvoice = "RAinvoice"
export const RAOrder = "RAOrder"
export const Stock = "Stock"
export const ItemRegister = "ItemRegisterReport"
export const IBinvoice = "IBinvoice"
export const VanLoadingSheetSKU = "VanLoadingSheetSKU"
export const VanLoadingPartyWiseInvoice = "VanLoadingPartyWiseInvoice"
export const Receipt = "Receipt"
export const Credit = "Credit"
export const PartyLedger = "PartyLedger"
export const Return = "Return"
export const MasterClaim = "MasterClaim"
export const ItemWiseClaim = "ItemWiseClaim"
export const CustomerWiseClaim = "CustomerWiseClaim"
export const PosInvoice = "PosInvoice"
export const ordeItemSupplier = "ordeItemSupplier"
export const StockEntry = "StockEntry"
export const orderThermalPrintReport = "orderThermalPrintReport"
export const VoucherRedemptionClaimReport = "VoucherRedemptionClaimReport"
export const PeriodicGRN = "PeriodicGRN"
export const POSSaleSummary = "POSSaleSummary"
export const CSS_ItemSaleReport = "CSS_ItemSaleReport"
export const RateReport = "RateReport"
export const LoyaltyClaimReport = "LoyaltyClaimReport"
export const Cashier_Summary_Report = "Cashier_Summary_Report"
export const Manager_Summary_Report = "Manager_Summary_Report"
export const Sale_Summary_Thermal_Print_Report = "Sale_Summary_Thermal_Print_Report"
export const CashBookReport = "CashBookReport";
export const billDeleteSummaryReport = "billDeleteSummaryReport"
export const Item_Consumption_Report = "Item_Consumption_Report"
export const Stockadjustment_Report = "Stockadjustment_Report"

export const Batch_Traceability_Report = "Batch_Traceability_Report"

export const Period_Wise_Item_Sale = "Period_Wise_Item_Sale"

export const Period_Wise_Invoice_Report = "Period_Wise_Invoice_Report"

export const Bill_Processing_Report = "Bill_Processing_Report"

export const Annual_Item_Sale_Report = "Annual_Item_Sale_Report";

export const VoucherRedemptionCouponReport = "VoucherRedemptionCouponReport"




const generateReport = (resp) => {

    switch (resp.ReportType) {
        case order1:
            ordeRreport(resp.Data)
            break;
        case schemeMaster:
            schemeMasterReport(resp.Data)
            break;
        case VoucherRedemptionCouponReport:
            VoucherRedemptionCouponPDF(resp)
            break;
        case wastage1:
            WastageReport(resp.Data)
            break;
        case wastage:
            WastageReport1(resp.Data)
            break;
        case invoice:
            InvioceReport(resp.Data)
            break;
        case RAinvoice:
            InvioceReport_RAMasale(resp.Data)
            break;
        case RAChallan:
            DeliveryChallanReport_RAMasale(resp.Data)
            break;
        case RAOrder:
            OrderReport_RAMasale(resp.Data)
            break;
        case Stock:
            StockReport(resp.Data)
            break;
        case ItemRegister:
            ItemRegisterReport(resp.Data)
            break;
        case IBinvoice:
            InvioceReport(resp.Data)
            break;
        case VanLoadingPartyWiseInvoice:
            VanLoadingSheet(resp.Data)
            break;
        case Receipt:
            Receipts(resp.Data)
            break;
        case Credit:
            CreditNote(resp.Data)
            break;
        case PartyLedger:
            PartyLedgerReport(resp.Data)
            break;
        case Return:
            ReturnReport(resp.Data)
            break;
        case MasterClaim:
            MasterClaimReport(resp.Data)
            break;
        case CashBookReport:
            CashBookReportPDF(resp.Data)
            break;
        case ItemWiseClaim:
            ItemWiseClaimReport(resp.Data)
            break;
        case CustomerWiseClaim:
            CustomerWiseClaimReport(resp.Data)
            break;
        case FrenchiesesOrder:
            FrenchiesesOrderReport(resp.Data)
            break;
        case PosInvoice:
            PosInvoiceReport(resp.Data)
            break;
        case ordeItemSupplier:
            ordeItemSupplierReport(resp.Data)
            break;
        case StockEntry:
            StockEntryReport(resp.Data)
            break;
        case orderThermalPrintReport:
            OrderThermalPrintReport(resp.Data[0])
            break;
        case VoucherRedemptionClaimReport:
            voucherRedemptionClaimReport(resp)
            break;
        case PeriodicGRN:
            PeriodicGRNReport(resp.Data)
            break;
        case POSSaleSummary:
            POSSaleSummaryReport(resp.Data)
            break;
        case CSS_ItemSaleReport:
            CSSItemSaleReport(resp.Data)
            break;
        case RateReport:
            RateListRepot(resp.Data)
            break;
        case LoyaltyClaimReport:
            LoyaltyReport(resp.Data)
            break;
        case Cashier_Summary_Report:
            CashierSummaryReport(resp.Data)
            break;
        case Manager_Summary_Report:
            ManagerSummaryReport(resp.Data)
            break;
        case Sale_Summary_Thermal_Print_Report:
            SaleSummaryThermalPrintReport(resp.Data)
            break;
        case billDeleteSummaryReport:
            BillDeleteSummaryReport(resp.Data)
            break;
        case Item_Consumption_Report:
            ItemConsumptionReport(resp.Data)
            break;
        case Batch_Traceability_Report:
            BatchTraceabilityReport(resp.Data)
            break;
        case Stockadjustment_Report:
            StockadjustmentReport(resp.Data)
            break;

        case Period_Wise_Item_Sale:
            PeriodWiseItemSale(resp.Data)
            break;
        case Period_Wise_Invoice_Report:
            PeriodWiseInvoiceReport(resp.Data)
            break;
        case Bill_Processing_Report:
            BillProcessingReport(resp.Data)
            break;
            case Annual_Item_Sale_Report:
                AnnualItemSalePDF(resp.Data, resp)
                break;
            


        default:
            break;
    }
}
export default generateReport;